<template>
  <!--begin::Modal - Create Bank Account -->
  <div
    :id="identifier"
    :ref="identifier"
    aria-hidden="true"
    class="modal fade"
    tabindex="-1"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered" :class="modalDialogClasses">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div :id="`${identifier}-header`" class="modal-header">
          <!--begin::Modal title-->
          <slot name="header">
            <!-- Default header content -->
          </slot>
          <!--end::Modal title-->

          <slot name="header-close">
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
              data-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </slot>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->

        <!--begin::Form-->
        <!--begin::Modal body-->
        <div class="modal-body py-10 px-lg-17">
          <!--begin::Scroll-->
          <slot name="body">
            <!-- Default body content -->
          </slot>
          <!--end::Scroll-->
        </div>
        <!--end::Modal body-->

        <!--begin::Modal footer-->
        <div class="modal-footer flex-center">
          <slot name="footer"></slot>
        </div>
        <!--end::Modal footer-->
        <!--end::Form-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-custom-modal",
  props: {
    identifier: {
      type: String,
      required: true,
    },
    modalDialogClasses: {
      type: String,
      default: "",
    },
  },
});
</script>
